import * as React from "react";
import { AppUtilities } from "./facetech/app-utilities";
import { FaceTecSDK } from "./../../../core-sdk/FaceTecSDK.js/FaceTecSDK";
import FaceTecStrings from "./../../../core-sdk-optional/FaceTecStrings.pt-br";
import { BmgThemeHelpers } from "./facetech/bmg-theme-helpers";
import { Config } from "./../../Config";
import { LivenessCheckProcessor } from "./facetech/liveness-check-processor";
import FaceValidationErroComponent from  '../face-validation-erro/face-validation-erro.component';
import FaceValidationSucessoComponent from  './../face-validation-sucesso/face-validation-sucesso.component';

interface State {
  statusFace: number;
  latestProcessor: any;
  isValidFace: boolean;
  latestSessionResult: any;
  latestIDScanResult: any;
  latestEnrollmentIdentifier: string;

}
export default class FaceValidationComponent extends React.Component<{}, State>{
  constructor(props: {}) {
    super(props);
    this.state = {
      statusFace: 1,
      latestProcessor: null,
      isValidFace: false,
      latestSessionResult: null,
      latestIDScanResult: null,
      latestEnrollmentIdentifier: ""

    };
  }
  async componentDidMount() {
    this.onLivenessCheckPressed()
  }
  onLivenessCheckPressed() {
    AppUtilities.fadeOutMainUIAndPrepareForSession();
    this.getSessionToken(function (this: FaceValidationComponent, sessionToken: string, keyFaceTech: string) {
      FaceTecSDK.setResourceDirectory("../core-sdk/FaceTecSDK.js/resources");
      FaceTecSDK.setImagesDirectory("../core-sdk/FaceTec_images");

      FaceTecSDK.initializeInProductionMode(keyFaceTech, Config.DeviceKeyIdentifier, Config.PublicFaceScanEncryptionKey, 
        function (this: FaceValidationComponent, initializedSuccessfully: boolean) {
          if (initializedSuccessfully) {
            FaceTecSDK.configureLocalization(FaceTecStrings);
            AppUtilities.enableAllButtons();
            BmgThemeHelpers.setAppTheme(BmgThemeHelpers.getCurrentTheme());
            this.setState({ latestProcessor: new LivenessCheckProcessor(sessionToken, this) });
          }
          else this.setState({ statusFace: 3 });
       
        }.bind(this));

      AppUtilities.formatUIForDevice();
    }.bind(this));
  }

  getSessionToken(sessionTokenCallback) {

  var jsonFace = localStorage.getItem("f_");
  if(!jsonFace){ this.onServerSessionTokenError();return;} 
  var json = JSON.parse(jsonFace);
  sessionTokenCallback(json.sessionToken, json.keyFaceTech);
  }

  onComplete() {
    const { latestProcessor } = this.state;
    AppUtilities.showMainUI();
    FaceTecSDK.setCustomization(Config.retrieveConfigurationWizardCustomization(FaceTecSDK));
    if (!latestProcessor.isSuccess())this.setState({latestEnrollmentIdentifier: ""});
    if (latestProcessor.success)this.setState({latestEnrollmentIdentifier: "", statusFace: 2 });
    else this.setState({ statusFace: 3 });
  }
  onServerSessionTokenError() {
    this.setState({ statusFace: 3 });
    AppUtilities.handleErrorGettingServerSessionToken();
  }
  setLatestSessionResult(sessionResult) {
    this.setState({ latestSessionResult: sessionResult });
  }

  setIDScanResult(idScanResult) {
    this.setState({ latestIDScanResult: idScanResult });
  }

  getLatestEnrollmentIdentifier() {
    const { latestEnrollmentIdentifier } = this.state;
    return latestEnrollmentIdentifier;
  }

  clearFace(){
    localStorage.removeItem("f_");
  }

  render() {
    const { statusFace } = this.state;
    
    if (statusFace == 1)return (<div className="wrapping-box-container"></div>)
    else if(statusFace == 2){this.clearFace(); return <FaceValidationSucessoComponent/>} 
    else {this.clearFace(); return  <FaceValidationErroComponent/>}
  }
}

